import { List, Map } from 'immutable';
import { records as buildsRecords, types as buildsTypes } from '@saucelabs/sl-module-builds';
import { records as jobsRecords, types as jobsTypes } from '@saucelabs/sl-module-jobs';

import * as types from './types';
import { types as filterTypes } from './../filters';

const initialState = Map({
  builds: List(),
  buildsLoading: true,
  expandedBuilds: List(),
  failedJobs: Map(),
});

const jobsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case buildsTypes.BUILDS_GET.FAILURE:
      return state.set('buildsLoading', false);
    case buildsTypes.BUILDS_GET.SUCCESS: {
      const builds = payload.map((build) => (
        new buildsRecords.BuildRecord({
          ...build,
          status: build.status || 'new',
        })
      ));
      return state.withMutations((mutable) => (
        mutable
          .set('builds', List(builds))
          .set('buildsLoading', false)
      ));
    }
    case types.TOGGLE_BUILD_CARD: {
      const index = state.get('expandedBuilds').indexOf(payload);
      return index === -1 ?
        state.update('expandedBuilds', (expandedBuilds) => expandedBuilds.push(payload)) :
        state.update('expandedBuilds', (expandedBuilds) => expandedBuilds.delete(index));
    }
    case jobsTypes.FAILED_JOBS_GET.SUCCESS: {
      if (!payload.length) {
        return state;
      }
      const jobs = payload.map((job) => new jobsRecords.JobRecord(job));
      return state.setIn(['failedJobs', jobs[0].build], jobs);
    }
    case filterTypes.CLEAR_OWNER:
    case filterTypes.CLEAR_STATUSES:
    case filterTypes.SELECT_OWNER:
    case filterTypes.TOGGLE_STATUS:
      return state.set('buildsLoading', true);
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default jobsReducer;
